import type { NavigationScreenLegacyIntegrationsState } from '@gitbook/app-navigation';

import { NavigationRedirect, NavigationScreenWithOrganization } from '../../navigation';

/** Redirect a legacy integration URL to its organization settings equivalent. */
export function IntegrationsLegacyRedirect(props: {
    screen: NavigationScreenLegacyIntegrationsState;
}): React.ReactElement {
    const { screen } = props;

    return (
        <NavigationScreenWithOrganization screen={screen}>
            {({ screen: organizationScreen }) => (
                <NavigationRedirect
                    to={{
                        screen: {
                            type: 'org_settings',
                            organization: organizationScreen.organization,
                            tab: organizationScreen.integration
                                ? {
                                      type: 'integrations',
                                      integration: organizationScreen.integration,
                                      tab: organizationScreen.tab,
                                      installation: organizationScreen.installation,
                                  }
                                : {
                                      type: 'integrations',
                                      category: organizationScreen.category,
                                      search: organizationScreen.search,
                                      provider: organizationScreen.provider,
                                  },
                        },
                    }}
                    replace
                />
            )}
        </NavigationScreenWithOrganization>
    );
}
